/* eslint-disable no-unused-vars */

import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom"
import { connect, useDispatch } from 'react-redux';
import Form from "react-bootstrap/Form";
import PropTypes from 'prop-types';
import { reset, resetPasswordState } from '../../actions/auth';
import FadeLoader from "react-spinners/FadeLoader";
import { LoginMain } from '../../styles/common.style';
const ResetPassword = ({ reset, resetPasswordFailure, resetPasswordSuccess, resetPasswordRequest }) => {
  const [formData, setFormData] = useState(
    {
      email: "",
      password: "",
      password_confirmation: "",
      otp_code: null
    }
  );
  const dispatch = useDispatch();

  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false)
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);

  const { email, password, password_confirmation, otp_code } = formData
  let navigate = useNavigate();
  const toHome = () => navigate("/", { replace: true })

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // Allow only numeric input

    const newOtp = [...otp];
    newOtp[index] = value;

    setOtp(newOtp); // Update the OTP state

    // Move to the next input if a digit is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(paste)) return; // only allow digits

    const pastedOtp = paste.split("").slice(0, 6); // max 6 digits
    const newOtp = [...otp];

    pastedOtp.forEach((digit, i) => {
      newOtp[i] = digit;
      if (inputRefs.current[i]) {
        inputRefs.current[i].value = digit;
      }
    });

    setOtp(newOtp);

    // focus next empty input (optional)
    const nextEmptyIndex = pastedOtp.length < 6 ? pastedOtp.length : 5;
    if (inputRefs.current[nextEmptyIndex]) {
      inputRefs.current[nextEmptyIndex].focus();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const otpCode = otp.join(""); // Combine the OTP array into a single string
    const formDataWithOtp = { ...formData, otp_code: otpCode, email: location.state.email };
    reset(formDataWithOtp); // Pass the updated formData to the reset function

  };

  useEffect(() => {
    if (resetPasswordSuccess) {
      navigate("/login", { replace: true });
    }
  }, [resetPasswordSuccess, navigate]);

  useEffect(() => {
    dispatch(resetPasswordState());
  }, [dispatch]);

  return (
    <div>
      <LoginMain>
        <div className='login-main-block'>
          <div className='login-main-block-left'>
            <div className='login-main-block-left-link'>
              <Link to='/'>
                {/* <img src='/images/auth-logo.svg' alt='img' /> */}
                <img src='/images/logo-auth-2.png' alt='img' />
              </Link>
            </div>
            <div className='login-main-block-left-banner'>
              <img src='/images/login-banner.png' alt='login-banner' />
            </div>
          </div>
          <div className='login-main-block-right'>
            <div className='login-form-block'>
              <div className='login-form-block-title'>
                <h2>Reset Your Password</h2>
              </div>
              <Form className='form-main' onSubmit={onSubmit}>
                <div className='otp-block-input mb-5'>
                  {otp.map((value, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      type='text'
                      value={value}
                      maxLength='1'
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      onPaste={(e) => index === 0 && handlePaste(e)}
                    />
                  ))}
                </div>
                <Form.Group className='form_signup'>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    className=''
                    placeholder='Enter New Password'
                    id='password-field'
                    name='password'
                    value={password}
                    onChange={onChange}
                    autoComplete='new-password'
                    required
                  />
                  <span
                    toggle='#password-field'
                    className={
                      showPassword
                        ? 'fa fa-fw fa-eye field-icon toggle-password'
                        : 'fa fa-fw fa-eye-slash field-icon toggle-password '
                    }
                    onClick={() => setShowPassword(!showPassword)}></span>
                  <div className='form-sign-icon'>
                    <img src='/images/password-icon.svg' alt='icon-block' />
                  </div>
                </Form.Group>
                <Form.Group className='form_signup'>
                  <Form.Control
                    type={showPasswordConfirm ? 'text' : 'password'}
                    className=''
                    placeholder='Confirm New Password '
                    id='password-field1'
                    name='password_confirmation'
                    onChange={onChange}
                    value={password_confirmation}
                    autoComplete='new-password'
                    required
                  />
                  <span
                    toggle='#password-field1'
                    className={
                      showPasswordConfirm
                        ? 'fa fa-fw fa-eye field-icon toggle-password'
                        : 'fa fa-fw fa-eye-slash field-icon toggle-password '
                    }
                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}></span>
                  <div className='form-sign-icon'>
                    <img src='/images/password-icon.svg' alt='icon-block' />
                  </div>
                </Form.Group>
                <div className='bottom-auth-block'>
                  <div className='common-btn-main'>
                    <button className='btn btn-common-auth'>Save</button>
                  </div>
                  <p className='sign-text-block'>
                    Go to <Link to='/login'>Sign in</Link>
                  </p>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </LoginMain>
    </div>
  );

}
ResetPassword.propTypes = {
  reset: PropTypes.func.isRequired,
  resetPasswordRequest: PropTypes.bool,
  resetPasswordSuccess: PropTypes.bool.isRequired,
  resetPasswordFailure: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  resetPasswordRequest: state.auth.resetPasswordRequest || null,
  resetPasswordSuccess: state.auth.resetPasswordSuccess || null,
  resetPasswordFailure: state.auth.resetPasswordFailure || null,
});

export default connect(mapStateToProps, { reset })(ResetPassword)


